import styled from "@emotion/styled";

export const Header = styled.div`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
`;
